import request from "@/utils/request";

// 查询用户手册树形列表
export function getUserManualTreeList(data) {
  return request({
    url: "/apis/emc/hc/userManual/getUserManualTreeList", // 后端接口
    method: "post",
    data
  });
}

// 查询用户手册正文内容
export function getUserManualTextContent(data) {
  return request({
    url: "/apis/emc/hc/userManual/getUserManualTextContent", // 后端接口
    method: "post",
    data
  });
}
